<template>
  <div>
    <div class="right-title">
      <span>邀请统计</span>
    </div>
    <div class="content-box">
<!--      <div class="search-box">-->
<!--        <el-input-->
<!--          class="search"-->
<!--          type="text"-->
<!--          placeholder="请输入ID/姓名"-->
<!--          v-model="search"-->
<!--        >-->
<!--        </el-input>-->
<!--        <el-button class="btn2" @click="keyWord" type="primary" style="margin-left: 10px;">搜索</el-button>-->
<!--      </div>-->
      <div class="tab-box">
        <el-table
          ref="multipleTable"
          :data="list"
          tooltip-effect="dark"
          style="width: 100%;height: 100%"
          :header-cell-style="{background: '#f2f3f5',color: '#000;'}"
        >
          <el-table-column
            prop="user_id"
            label="ID"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="user_real_name"
            label="姓名"
            align="center"
          >
          </el-table-column>

          <el-table-column
            prop="candidateCount"
            label="候选人邀请数量"
            align="center"
          >
            <template slot-scope="scope">
              <span style="cursor: pointer;color: #00a2ea;" @click="toDetail(scope.row.user_id)" v-if="scope.row.candidateCount!==0">{{scope.row.candidateCount}}</span>
              <span style="cursor: pointer" v-else>{{scope.row.candidateCount}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="orgCount"
            label="机构邀请数量"
            align="center"
          >
            <template slot-scope="scope">
              <span style="cursor: pointer;color: #00a2ea;" @click="toDetail2(scope.row.user_id)" v-if="scope.row.orgCount!==0">{{scope.row.orgCount}}</span>
              <span style="cursor: pointer" v-else>{{scope.row.orgCount}}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="page-box">
          <!--          <el-button type="danger" @click="deleteList()">删除</el-button>-->
          <div></div>
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page.pageNum"
            :page-size="page.pageSize"
            layout="prev, pager, next, jumper"
            :total="page.pageTotal">
          </el-pagination>
        </div>
      </div>
    </div>
    <footerBox class="footer"/>
  </div>
</template>

<script>
  import footerBox from '../components/rightBottom'

  export default {
    name: "hxrPaiming",
    data() {
      return {
        search: '',  // 搜索
        zuiJ:'',
        tableData: [],
        multipleSelection: [], //  选中的
        page:{
          pageNum:1,
          pageSize:10 ,
          pageTotal:1
        },
        timeIndex:0
      }
    },
    computed: {
      list(){
        let _list = JSON.parse(JSON.stringify(this.tableData))
        _list.map(item => {
          //推荐
          item.jinzhituijian = item.jinzhituijian === 1 ? (true) : (false)
        })
        return _list
      },
      user(){
        return this.$store.state.user
      }
    },
    created() {
      this.$emit('setType', 6)
      this.paimingList()
    },
    methods: {
      toDetail(id){
        this.$router.push({
          path:'/home/hxrAdmin/hxraddList',
          query:{
            id:id
          }
        })
      },
      toDetail2(id){
        this.$router.push({
          path:'/home/hxrAdmin/orgaddList',
          query:{
            id:id
          }
        })
      },
      // 列表
      paimingList() {
        const loading = this.$loading({
          target: this.$refs.listBox,
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.7)'
        });
        if(this.$route.query.pageNum){
          this.page.pageNum = Number(this.$route.query.pageNum)
        }else {
          this.page.pageNum = 1
        }
        if(this.$route.query.key){
          this.search =this.$route.query.key
        }else {
          this.search = ''
        }
        if(this.$route.query.zuiJ){
          this.zuiJ =Number(this.$route.query.zuiJ)
        }else {
          this.zuiJ = ''
        }
        if(this.$route.query.timeIndex){
          this.timeIndex =Number(this.$route.query.timeIndex)
        }else {
          this.timeIndex = ''
        }
        this.$api.apiContent.userInvitationStatistics({
          search:this.search,
          page:this.page.pageNum,
          pageSize:this.page.pageSize,
          adminId:this.user.id
        }).then(res => {
           loading.close();
          this.page.pageNum = res.now_page
          this.page.pageTotal = res.total_number
          this.tableData = res.data
        }).catch(() => {
           loading.close();
          this.tableData = []
          this.page.pageTotal = 0
        })

      },
      tuiJian(id) {
        let state = ""
        this.tableData.map(item =>{
          if(item.tj_id === id) {
            state = item.jinzhituijian
          }
        })
        let messg = ""
        if(!state){
          messg = "此操作将不推荐到, 是否继续?"
        }else {
          messg = "此操作将推荐, 是否继续?"
        }
        this.$confirm(messg, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api.apiContent.hxrPaimtuij({
            tj_id:id,
            admin_id:this.user.id
          }).then(res => {
            this.$message({
              type: 'success',
              message: res.info
            });
            this.paimingList()
          }).catch(res => {
            this.$message.error(res.info);
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      handleSizeChange(num){        //  点击分页
        this.page.pageNum = num
      },
      handleCurrentChange(num){     //  选择页数
        this.page.pageNum = num
      },
      keyWord() {     //  搜索
        if(this.page.pageNum === 1){
          this.zuiJ = ''
          this.timeIndex = 0
          this.setPath()
        }else{
          this.page.pageNum = 1
        }
      },

      //最近7天
      zuiJinqi(){
        this.timeIndex = 1
        this.zuiJ = parseInt((new Date().getTime() / 1000)) - (7 * 86400)
      },
      //最近30天
      zuiJinsans(){
        this.timeIndex = 2
        this.zuiJ = parseInt((new Date().getTime() / 1000)) - (30 *86400)
      },
      //最近90天
      zuiJinjius(){
        this.timeIndex =3
        this.zuiJ = parseInt((new Date().getTime() / 1000)) - (90 * 86400)
      },
      //  修改路径
      setPath(){
        this.$router.push({
          path:'/home/hxrAdmin/addList',
          query:{
            pageNum:this.page.pageNum,
            // key:this.search,
            // zuiJ:this.zuiJ,
            // timeIndex:this.timeIndex
          }
        })
      },
    },
    watch: {
      zuiJ(){
        this.setPath()
      },
      'page.pageNum'(){
        this.setPath()
      },
      $route(){
        this.paimingList()
      }
    },
    components: {
      footerBox
    }
  }
</script>

<style scoped lang="scss">
  .search-box {
    position: absolute;
    top: 10px;
    left: 10px;
    right: 10px;
    z-index: 1;
    display: flex;
    justify-content: flex-end;


    .search {
      width: 220px;
      /*position: absolute;*/
      /*right: 80px;*/
      /*border-radius: 4px !important;*/
    }
    div{
      display: flex;
      span{
        display: block;
        line-height: 40px;
        font-size: 16px;
        margin: 0 10px;
        cursor: pointer;
      }
    }
    .btn7 {
      color: #333;
      &.active{
        color: #00a2ea;
      }
    }
    .btn30 {

      color: #333;
      &.active{
        color: #00a2ea;
      }
    }
    .btn90 {
      color: #333;
      &.active{
        color: #00a2ea;
      }
    }
  }
  .tab-box {
    position: relative;
    /*top: 64px;*/
    /*left: 10px;*/
    /*right: 10px;*/
    /*bottom: 60px;*/
    min-height: 100%;
    padding-top: 20px;
    padding-bottom: 60px;
    background: #fff;


    .page-box{
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: 60px;
      padding: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }

</style>